import { get } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';

import {
  Box,
  Drawer as ChakraDrawer,
  CloseButton,
  DrawerContent,
  DrawerOverlay,
  IconButton,
  Image,
  Stack,
  useMediaQuery,
  useOutsideClick,
  Button
} from '@chakra-ui/react';
import { useLocation } from '@reach/router';
import { StaticQuery, graphql, navigate } from 'gatsby';
import { CSSTransition } from 'react-transition-group';
import AuthContext from '../../../../context/AuthProvider';
import CartContext from '../../../../context/CartProvider';
import { useGlobalStore } from '../../../../stores/global';
import Brand from '../../../atoms/Brand/Brand';
import Container from '../../../atoms/Container/Container';
import Icon from '../../../atoms/Icon/Icon';
import LoadingOverlay from '../../../atoms/LoadingOverlay/LoadingOverlay';
import Notification from '../../../molecules/Notification/Notification';
import CustomSearch from '../InstaSearch/CustomSearch';
import * as styles from './Header.module.scss';
import HeaderMenu from './HeaderMenu';
import MobileDrawerContent from './MobileDrawerContent';

const Header = (props) => {
  const [isPc] = useMediaQuery('(min-width: 1025px)', {
    ssr: true,
    fallback: false // return false on the server, and re-evaluate on the client side
  });
  const [isTablet] = useMediaQuery('(max-width: 800px)', {
    ssr: true,
    fallback: false
  });

  const [lastScrollPos, setLastScrollPos] = useState(0);

  const { setShowSearch, showSearch, showHeader, setShowHeader, trackHeaderScroll } =
    useGlobalStore((state) => state);
  const { pathname } = useLocation();

  const auth = useContext(AuthContext);
  const isLoggedIn = auth && auth.state.isLoggedIn;

  const config = props?.oneConfig?.data;
  const cartCtx = useContext(CartContext);
  const cartState = get(cartCtx, 'state.cart', false);

  // const [showMiniCart, setShowMiniCart] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [highlightedMenu, setHighlighedMenu] = useState(undefined);
  const [activeMenu, setActiveMenu] = useState(undefined);
  const [activeSubMenu, setActiveSubMenu] = useState(undefined);

  const megaMenuRef = useRef();
  const headerRef = useRef();

  useOutsideClick({
    ref: megaMenuRef,
    handler: () => {
      setShowMenu(false);
      setHighlighedMenu(undefined);
    }
  });

  // useHoverOutside([megaMenuRef, headerRef], () => {
  //   setShowMenu(false);
  //   setHighlighedMenu(undefined);
  // });

  const navigateHandler = (url) => {
    setMobileMenu(false);

    window.location = url;
  };
  useEffect(() => {
    const handleScroll = () => {
      if (trackHeaderScroll) {
        // setShowMenu(false);

        if (isTablet) {
          const currentScrollPos = window?.scrollY ?? 0;

          if (currentScrollPos > 150) {
            const isScrollingUp = currentScrollPos < lastScrollPos;
            setShowHeader(isScrollingUp);
          }
          setLastScrollPos(currentScrollPos);
        }
      } else {
        setShowHeader(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastScrollPos, isTablet, trackHeaderScroll]);

  return (
    <>
      <div className={`${styles.root} ${showHeader ? '' : 'hide'}`}>
        <a className={styles.headerMessageContainer} href={config?.shippingBannerLink ?? '/'}>
          <span>{config?.shippingBanner ?? ''} &nbsp;</span>
        </a>
        <Container size={'large'} spacing={'min'}>
          <div className={`${styles.headerLayout} ${showSearch ? 'active' : ''}`} ref={headerRef}>
            <div
              role={'presentation'}
              onClick={() => {
                setMobileMenu(!mobileMenu);
                // setDepth(0);
              }}
              className={styles.burgerIcon}
            >
              <Icon symbol={`${mobileMenu === true ? 'cross' : 'burger'}`}></Icon>
            </div>

            {isPc ? <>{!showSearch && <Brand />}</> : <Brand />}

            <section className="header-search">
              <Icon symbol={'search'}></Icon>
              <CustomSearch hideSearch={setShowMenu} />
            </section>
            <div className={`${styles.actionContainers} header-actions`}>
              {showSearch ? (
                <CloseButton
                  size={'md'}
                  maxHeight={'inherit'}
                  maxWidth={'inherit'}
                  color={'rgba(20, 96, 122, 1)'}
                  fontSize={'1.3rem'}
                  padding={4}
                  onClick={() => setShowSearch(false)}
                />
              ) : (
                <>
                  {isLoggedIn ? (
                    <HeaderMenu ref={headerRef} />
                  ) : (
                    <IconButton
                      variant={'ghost'}
                      rounded={'full'}
                      role={'presentation'}
                      onClick={() => {
                        if (isLoggedIn) {
                          navigate('/account');
                        } else {
                          if (typeof window !== 'undefined') {
                            window.location = '/login';
                          }
                        }
                      }}
                      className={`${styles.iconContainer} ${
                        !showSearch ? styles.bagIconFadeIn : ''
                      }`}
                    >
                      <Icon symbol={'user'}></Icon>
                    </IconButton>
                  )}

                  <IconButton
                    variant={'ghost'}
                    rounded={'full'}
                    pos={'relative'}
                    className={`${styles.iconContainer} ${styles.bagIconContainer} ${
                      !showSearch ? styles.bagIconFadeIn : ''
                    }`}
                    role={'presentation'}
                    onClick={showSearch ? undefined : () => navigate('/confirm-order')}
                    icon={
                      <Box>
                        <Icon symbol={'bagAlt'} />
                        {cartState && (
                          <div className={styles.bagNotification}>{cartState.numberItems}</div>
                        )}
                      </Box>
                    }
                  >
                    <div className={styles.notificationContainer}>
                      <Notification />
                    </div>
                  </IconButton>
                </>
              )}
            </div>
            <div className="header-links">
              {config?.headerLinks?.map((link, index) => {
                return (
                  <div
                    key={index}
                    className={`${
                      link?.headerLinksItem.name?.toUpperCase() === 'SALE' ? 'sale-container' : ''
                    }`}
                  >
                    <Button
                      backgroundColor={'unset'}
                      _hover={{
                        bg: 'unset'
                      }}
                      color={'var(--bg-dark-blue)'}
                      onClick={() => {
                        if (link?.headerLinksItem?.subList) {
                          if (
                            showMenu &&
                            link?.headerLinksItem.link &&
                            highlightedMenu === link?.headerLinksItem?.name
                          ) {
                            setShowMenu(false);
                            setHighlighedMenu(undefined);
                          } else {
                            setActiveMenu(link?.headerLinksItem);
                            setActiveSubMenu(link?.headerLinksItem?.subList?.[0]);
                            setShowMenu(true);
                            setHighlighedMenu(link?.headerLinksItem?.name);
                          }
                        } else {
                          if (link?.headerLinksItem.link) {
                            navigateHandler(link?.headerLinksItem.link);
                          } else {
                            setHighlighedMenu(undefined);
                            setShowMenu(false);
                          }
                        }
                      }}
                      key={index}
                      // onClick={e => {
                      //   e.preventDefault();
                      //   navigateHandler(link?.headerLinksItem.link);
                      // }}
                      className={`linkColor ${
                        pathname.replace(/\//g, '') ===
                        link?.headerLinksItem.link.replace(/\//g, '')
                          ? 'active'
                          : ''
                      }
                        ${highlightedMenu === link?.headerLinksItem?.name ? 'highlighted' : ''}
                        ${link?.headerLinksItem.name?.toUpperCase() === 'SALE' ? 'sale' : ''}
                        `}
                    >
                      {link?.headerLinksItem.name}
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        </Container>

        {isPc && (
          <CSSTransition
            in={showMenu}
            timeout={300}
            classNames={{
              enter: styles.menuEnter,
              enterDone: styles.menuEnterActive,
              exit: styles.menuExit,
              exitActive: styles.menuExitActive
            }}
            unmountOnExit
          >
            <div ref={megaMenuRef} className={`${styles.searchContainer} ${styles.menu}`}>
              <Container size={'large'} spacing={'min'}>
                <div className={styles.searchContainerInner}>
                  <div className={styles.searchContainerInnerLeft}>
                    <Box as="ul" m={0}>
                      {activeMenu?.subList?.map((item, index) => (
                        <li key={index}>
                          <button
                            className={`${activeSubMenu?.title === item.title ? 'active' : ''}`}
                            onMouseEnter={() => {
                              setActiveSubMenu(item);
                            }}
                            onClick={() => navigateHandler(item.link)}
                          >
                            {item.title}
                            {item?.innerList && item?.innerList?.length > 0 && (
                              <Icon symbol={'chevRight'} />
                            )}
                          </button>
                        </li>
                      ))}

                      {activeMenu?.subListOthers &&
                        activeMenu?.subListOthers?.length > 0 &&
                        activeMenu?.subListOthers.map((item, index) => (
                          <li className={styles.searchContainerInnerLeftOthers} key={index}>
                            <button onClick={() => navigateHandler(item.link)}>{item.title}</button>
                          </li>
                        ))}
                    </Box>
                    <Stack as="ul" m={0}>
                      {activeMenu?.subBanners?.map((item, index) => (
                        <button onClick={() => navigateHandler(item.url)} key={index}>
                          <Image
                            maxH={50}
                            maxW={204}
                            w={'full'}
                            m={0}
                            src={item.image}
                            alt={item.title}
                          />
                        </button>
                      ))}
                    </Stack>
                  </div>
                  <div className={styles.searchContainerInnerRight}>
                    <div className={styles.searchContainerInnerRightLinks}>
                      {activeSubMenu &&
                        activeSubMenu?.innerList.map((item, index) => (
                          <React.Fragment key={index}>
                            <div>
                              <p>{item.title}</p>
                              {item.imageMode ? (
                                <ul className={styles.imageMode}>
                                  {item?.links?.map((item, index) => (
                                    <li key={index} className="shadow">
                                      <button onClick={() => navigateHandler(item.url)}>
                                        <Image src={item.image} alt={item.text} />
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <ul className={styles.textMode}>
                                  {activeSubMenu?.link && (
                                    <li>
                                      <button
                                        className="underline"
                                        onClick={() => navigateHandler(activeSubMenu?.link)}
                                      >
                                        View All
                                      </button>
                                    </li>
                                  )}

                                  {item?.links?.map((item, index) => (
                                    <li key={index}>
                                      <button
                                        className="underline"
                                        onClick={() => navigateHandler(item.url)}
                                      >
                                        {item.text}
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </React.Fragment>
                        ))}
                    </div>
                    <div className={styles.rightBanners}>
                      {activeMenu?.rightBanners?.map(({ banner }, index) => (
                        <a
                          href={banner.link}
                          key={index}
                          onClick={() => navigateHandler(banner.link)}
                        >
                          <Image src={banner.image} alt={banner.title} m={0} maxH={460} />
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </CSSTransition>
        )}

        {/* mobile menu */}
        <ChakraDrawer
          placement={'left'}
          onClose={() => setMobileMenu(false)}
          isOpen={mobileMenu && !isPc}
          isFullHeight={true}
        >
          <DrawerOverlay />
          <DrawerContent
            overflow={'hidden'}
            h={'calc(100dvh - env(safe-area-inset-bottom))'}
            maxH={'calc(100dvh - env(safe-area-inset-bottom))'}
          >
            <MobileDrawerContent
              onCloseModal={() => setMobileMenu(false)}
              data={config?.headerLinks}
            />
          </DrawerContent>
        </ChakraDrawer>
      </div>
      {(showMenu || showSearch) && isPc && (
        <LoadingOverlay
          clickEvent={() => {
            setShowMenu(false);
            setHighlighedMenu(undefined);
          }}
          loading={false}
          zIndex={5}
        />
      )}
    </>
  );
};

export default function BuilderHeader(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          allBuilderModels {
            oneConfig {
              data {
                shippingBannerLink
                shippingBanner
                headerLinks
              }
            }
          }
        }
      `}
      render={(data) => <Header {...data.allBuilderModels} {...props} />}
    />
  );
}
